import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { of, Observable, throwError, Subscription, fromEvent } from 'rxjs';
import { take, mergeMap, catchError, map, takeWhile } from 'rxjs/operators';
import * as i3 from 'abs-ngx-library/src/lib/core';
import { EnviormentConfig, SortModel, DatasScrollService, LoaderService } from 'abs-ngx-library/src/lib/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i6 from 'abs-ngx-library/src/lib/product-item-al-v2';
import { ProductItemALV2Module } from 'abs-ngx-library/src/lib/product-item-al-v2';
import * as i7 from 'abs-ngx-library/src/lib/sort';
import { SortByAlV1Module } from 'abs-ngx-library/src/lib/sort';
import { ProductItemALV1Module } from 'abs-ngx-library/src/lib/product-item-al-v1';

class ProductCatalogALV1Service {
    constructor(_http, _commonService, _userInfoService, _utilService) {
        this._http = _http;
        this._commonService = _commonService;
        this._userInfoService = _userInfoService;
        this._utilService = _utilService;
        // DFTA - wcax env config
        this.config = EnviormentConfig;
        this.currentEnv = '';
        this.currentEnv = this._commonService.getCurrentEnviorment();
        this.httpOptions = {
            headers: new HttpHeaders({
                'ocp-apim-subscription-key': this.getSubscriptionKey(this.config[this.currentEnv])
            })
        };
    }
    /**
    * This method returns either mockinator or search api subscription key.
    */
    getSubscriptionKey(envConfig) {
        const wiremockAPIDetails = envConfig?.wiremockAPIDetails;
        const mode = this._utilService.getParams('mode');
        // check if wiremock service is enabled
        if (wiremockAPIDetails?.allowWiremockService && (mode === 'record' || mode === 'playback')) {
            return wiremockAPIDetails?.subscriptionKey;
        }
        return envConfig?.searchAPIDetails?.subscriptionKey?.value;
    }
    /**
     * Method used for launching an HTTP request for BPN products.
     *
     * @param bpnString - BPN ids for the products
     * @param includeOffer - Flag if offers should be included in the response
     */
    getCatalogXapiProductPrice(bpnString, includeOffer) {
        const productsByBpnEndpoint = `${window['AB']['catalogXapiProductsBpnEndpoint']}`
            + `?store-id=${this._userInfoService.getShopStoreId()}`
            + `${includeOffer ? `&includeOffer=${includeOffer}` : ''}`
            + `&bpn=${bpnString}`;
        return this._http.get(productsByBpnEndpoint, this.httpOptions);
    }
    /**
     * Method used for launching an HTTP request for UPC products.
     *
     * @param upcString - UPC ids for the products
     * @param includeOffer - Flag if offers should be included in the response
     * @param sellerIdString - marketplace product's seller id
     */
    getCatalogXapiProductPriceByUPC(upcString, includeOffer, isGuestUser, hasHHId, appendChannel, sellerId, sellerIdString) {
        let productsByUpcEndpoint = `${window['AB']['catalogXapiProductsUpcEndpoint']}`
            + `?upc=${upcString}&banner=${window['AB']['userInfo']['banner']}`;
        if (isGuestUser) {
            productsByUpcEndpoint = `${productsByUpcEndpoint}&guest=${isGuestUser}`;
        }
        if (includeOffer) {
            productsByUpcEndpoint = `${productsByUpcEndpoint}&includeOffer=${includeOffer}`;
        }
        if (hasHHId) {
            const hhid = window['AB'] && window['AB']['userInfo'] && window['AB']['userInfo']['houseId']
                ? window['AB']['userInfo']['houseId']
                : '';
            productsByUpcEndpoint = `${productsByUpcEndpoint}&hhid=${hhid}`;
        }
        if (appendChannel) {
            productsByUpcEndpoint = this._commonService.generateCBAUrl(productsByUpcEndpoint);
        }
        // check if product is a marketplace product
        if (sellerIdString) {
            productsByUpcEndpoint = `${productsByUpcEndpoint}&seller-id=${sellerIdString}`;
        }
        // check if product is a marketplace product
        if (sellerId) {
            productsByUpcEndpoint = `${productsByUpcEndpoint}&sellerId=${sellerId}`;
        }
        // README: Make the api call only if storeId exists
        if (window['AB']['userInfo']['branchId']) {
            productsByUpcEndpoint = `${productsByUpcEndpoint}&store-id=${window['AB']['userInfo']['branchId']}`;
            return this._http.get(productsByUpcEndpoint, this.httpOptions);
        }
        return of({});
    }
    getCatalogData(objGridData) {
        let url = '';
        let strUrl = '';
        const wiremockAPIDetails = this.config[this.currentEnv].wiremockAPIDetails;
        const mode = wiremockAPIDetails?.allowWiremockService ? this._utilService.getParams('mode') : '';
        switch (objGridData.apiType) {
            case 'c-bogo':
            case 'c-club-card':
                break;
            case 'c-virtual-shelf-general':
            case 'c-virtual-shelf-promo':
                const virtualShelfId = objGridData.value[objGridData.apiType]['virtualShelfId'];
                const banner = window['AB']['userInfo']['banner'];
                strUrl = objGridData.apiUrl
                    + '?storeId=' + window['AB']['userInfo']['branchId']
                    + '&virtualShelfId=' + virtualShelfId + `&banner=${banner}`
                    + '&page=0&pageSize=999';
                url = this._commonService.generateCBAUrl(strUrl);
                // check if wiremock service is enabled
                if (wiremockAPIDetails?.allowWiremockService) {
                    // check mode coming from request parameter
                    if (mode === 'record') {
                        // prepend record base url to virtual shelf api endpoint
                        url = `${wiremockAPIDetails?.recorderBaseUrl}${url}`;
                    }
                    else if (mode === 'playback') {
                        // prepend playback base url to virtual shelf api endpoint
                        url = `${wiremockAPIDetails?.playbackBaseUrl}${url}`;
                    }
                }
                return this._http.get(url, this.httpOptions);
            case 'c-products-by-upc':
            case 'c-products-by-upc-drawer':
                const storeId = this._userInfoService.getShopStoreId();
                return this._commonService.$upcs
                    .pipe(take(1), mergeMap((arrUpc) => {
                    if (arrUpc && arrUpc.length > 0) {
                        const channel = this._userInfoService.getUserChannel();
                        const banner = this._userInfoService.getBanner();
                        const body = { 'ids': arrUpc, storeId, banner };
                        const requestBody = channel ? { ...body, channel } : body;
                        url = objGridData.apiUrl;
                        // check if wiremock service is enabled
                        if (wiremockAPIDetails?.allowWiremockService) {
                            // check mode coming from request parameter
                            if (mode === 'record') {
                                // prepend record base url to products-by-upc api endpoint
                                url = `${wiremockAPIDetails?.recorderBaseUrl}${url}`;
                            }
                            else if (mode === 'playback') {
                                // prepend playback base url to products-by-upc api endpoint
                                url = `${wiremockAPIDetails?.playbackBaseUrl}${url}`;
                            }
                        }
                        return this._http
                            .post(url, requestBody, this.httpOptions)
                            .pipe(catchError(() => of({ ack: true, response: { docs: [] } })));
                    }
                    else {
                        return of({ ack: true, response: { docs: [] } });
                    }
                }));
            default:
                break;
        }
    }
    static { this.ɵfac = function ProductCatalogALV1Service_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ProductCatalogALV1Service)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i3.CommonService), i0.ɵɵinject(i3.UserInfoService), i0.ɵɵinject(i3.UtilService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProductCatalogALV1Service, factory: ProductCatalogALV1Service.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductCatalogALV1Service, [{
        type: Injectable
    }], () => [{ type: i1.HttpClient }, { type: i3.CommonService }, { type: i3.UserInfoService }, { type: i3.UtilService }], null); })();

/**
 * Product Generic Grid Service - Get all required data
 *
 * @memberof Product-Generic-Grid
 */
class ProductGenericGridALV1Service {
    constructor(_http, _productCatalogALV1Service, _commonService, _userInfoService, _utilService, _p13nEndpointService) {
        this._http = _http;
        this._productCatalogALV1Service = _productCatalogALV1Service;
        this._commonService = _commonService;
        this._userInfoService = _userInfoService;
        this._utilService = _utilService;
        this._p13nEndpointService = _p13nEndpointService;
        this._config = EnviormentConfig;
        this.defaultNoResultsMsg = 'No products available.';
        this.objGridData = {
            drivenType: '',
            apiUrl: '',
            apiType: '',
            sorts: '',
            defaultSort: '',
            value: {},
            products: [],
            widgetId: ''
        };
        this._currentEnv = this._commonService.getCurrentEnviorment();
    }
    getData() {
        if (this.hasDynamicData() && !this.objGridData.doGenericFlow) {
            return this.getDynamicData();
        }
        else if (this.hasStaticData()) {
            return this.getStaticData();
        }
        else if (this.objGridData.doGenericFlow) {
            return this.getGenericData();
        }
        return of({
            'products': []
        });
    }
    getGenericData() {
        let objHttp = of([]);
        switch (this.objGridData.drivenType) {
            case 'generic':
                objHttp = this.getP13nProductsData();
        }
        return objHttp;
    }
    getP13nProductsData() {
        let dynamicFields = { modelConfigurationId: this.objGridData.modelConfigurationId, uiPageSize: 135, excludeCartItems: true, excludeOOS: true };
        let payload = this._p13nEndpointService.generateProductsRequestPayload(dynamicFields);
        return this._p13nEndpointService.getP13nProductsRecommendation(payload).pipe(map((response) => {
            return { products: response?.productsinfo, p13nAdobeMetrics: response?.p13nAdobeMetrics };
        }));
    }
    getDynamicData() {
        let objHttp = of([]);
        this.objGridData.drivenType = 'catalog';
        switch (this.objGridData.drivenType) {
            case 'catalog':
                objHttp = this._productCatalogALV1Service.getCatalogData(this.objGridData);
                break;
            case 'purchase':
                objHttp = this.getPurchaseData(this.objGridData);
                break;
            case 'relevancy':
                objHttp = this.getRelevancyData();
                break;
            default:
                objHttp = this.getDotNetData();
                break;
        }
        return objHttp;
    }
    getRelevancyData() {
        let objObservable = of({});
        let relevancyUrl = '';
        let bpn;
        let hhid;
        let storeId;
        let bearerToken;
        let httpOptions;
        let xAPIBasePath = 'https://www.safeway.com/abs/pub/xapi';
        //window['SWY'].CONFIGSERVICE.getDatapowerConfig().datapowerxAPIBasePath; //
        switch (true) {
            case (this.objGridData.apiType === 'similar-products'):
                bpn = window['AB']['COMMON'].getURLParameterByName('bpn');
                storeId = window['AB'] && window['AB']['userInfo'] && window['AB']['userInfo']['branchId']
                    ? window['AB']['userInfo']['branchId'] : '';
                relevancyUrl = `${xAPIBasePath}/pdreco/similarproducts?bpn=${bpn}&storeId=${storeId}`;
                httpOptions = {
                    headers: new HttpHeaders({
                        'Ocp-Apim-Subscription-Key': '7bad9afbb87043b28519c4443106db06',
                        'accept': 'application/json'
                    })
                };
                break;
            case (this.objGridData.apiType === 'substitution'):
                bpn = window['AB']['COMMON'].getURLParameterByName('bpn');
                hhid = window['AB'] && window['AB']['userInfo'] && window['AB']['userInfo']['houseId'] && window['AB']['COMMON'].getURLParameterByName('hhid')
                    ? window['AB']['COMMON'].getURLParameterByName('hhid') : '';
                storeId = window['AB'] && window['AB']['userInfo'] && window['AB']['userInfo']['branchId']
                    ? window['AB']['userInfo']['branchId'] : '';
                relevancyUrl = `${xAPIBasePath}/pdreco/substitution?bpn=${bpn}&storeId=${storeId}&hhid=${hhid}`;
                httpOptions = {
                    headers: new HttpHeaders({
                        'Ocp-Apim-Subscription-Key': '7bad9afbb87043b28519c4443106db06',
                        'accept': 'application/json'
                    })
                };
                break;
            case (!!this.objGridData.widgetId && !!this.objGridData.apiType):
                // HARD - CODED URL FOR POC ONLY //
                const query = window['AB']['COMMON'].getURLParameterByName('query');
                const item_ids = window['AB']['COMMON'].getURLParameterByName('item_ids');
                relevancyUrl = 'https://pathways.dxpapi.com/api/v2/widgets/' + this.objGridData.apiType + '/'
                    + this.objGridData.widgetId
                    + '?_br_uid_2=uid%3D2582397584083%3Av%3D12.0%3Ats%3D1587279462499%3Ahc%3D358&account_id=6175&url=www.bloomique.com&domain_key=albertsons&request_id=1597706996821&fields=name%2CaisleId%2Cpid%2Cupc%2Cprice%2CbasePrice%2CpricePer%2Cquantity%2CquantityOrder%2CunitOfMeasure%2CpromoDescription%2CsalesRank%2CdepartmentName%2CpromoType%2CpromoTitle%2CpromoText%2CofferText%2CpromoEndDate%2CrestrictedValue&rows=30&start=0&query=' + query + '&item_ids=' + item_ids;
                // const apimKey = window['SWY']['CONFIGSERVICE']['omsConfig']['swy.api.purchase.service.purchases.apim.key']
                bearerToken = window['AB']['userInfo']['SWY_SHOP_TOKEN'];
                httpOptions = {
                    headers: new HttpHeaders({
                        'ocp-apim-subscription-key': 'e914eec9448c4d5eb672debf5011cf8f',
                        'Authorization': 'Bearer ' + bearerToken,
                        'accept': 'application/json'
                    })
                };
                break;
            default:
                // HARD - CODED URL FOR POC ONLY //
                bpn = window['AB']['COMMON'].getURLParameterByName('bpn');
                relevancyUrl = 'https://www.safeway.com/api/v1/core/Search_Results?account_id=6175&auth_key=eyxny75nafpl1ra4&domain_key=albertsons&request_id=8913801407865&_br_uid_2=uid%253D4195525208755%253Av%253D12.0%253Ats%253D1602201845750%253Ahc%253D90&url=https://www.safeway.com&ref_url=https://www.safeway.com&request_type=mlt&fl=name,aisleId,pid,upc,price,basePrice,pricePer,quantity,quantityOrder,unitOfMeasure,promoDescription,salesRank,departmentName,promoType,promoTitle,promoText,offerText,promoEndDate,restrictedValue,unitQuantity,displayEstimateText,displayUnitQuantityText&rows=12&start=0&sort=&view_id=1502&pid='
                    + bpn + '&facet=false';
                // const apimKey = window['SWY']['CONFIGSERVICE']['omsConfig']['swy.api.purchase.service.purchases.apim.key']
                bearerToken = window['AB']['userInfo']['SWY_SHOP_TOKEN'];
                httpOptions = {
                    headers: new HttpHeaders({
                        'ocp-apim-subscription-key': 'e914eec9448c4d5eb672debf5011cf8f',
                        'Authorization': 'Bearer ' + bearerToken,
                        'accept': 'application/json'
                    })
                };
                break;
        }
        objObservable = this._http.get(relevancyUrl, httpOptions).pipe(catchError(() => of({ purchases: null, purchasesCount: 0 })));
        return objObservable;
    }
    getPurchaseData(apiData) {
        let objObservable = of({});
        const apimKey = window['SWY']['CONFIGSERVICE']['omsConfig']['swy.api.purchase.service.purchases.apim.key'];
        const bearerToken = window['AB']['userInfo']['SWY_SHOP_TOKEN'];
        const httpOptions = {
            headers: new HttpHeaders({
                'ocp-apim-subscription-key': apimKey,
                'Authorization': 'Bearer ' + bearerToken,
                'accept': 'application/json'
            })
        };
        let purchasesUrl = apiData.apiUrl;
        const storeId = window['AB'] && window['AB']['userInfo'] && window['AB']['userInfo']['branchId']
            ? window['AB']['userInfo']['branchId']
            : '';
        switch (apiData.apiType) {
            case 'buy-it-again':
                //objObservable = this._buyItAgainService.getBiaProducts(this.objGridData);
                break;
            default:
                const customerId = window['AB'] && window['AB']['userInfo'] && window['AB']['userInfo']['customerId']
                    ? window['AB']['userInfo']['customerId']
                    : '';
                purchasesUrl = `${purchasesUrl}/${customerId}?storeId=${storeId}`;
                purchasesUrl = this._commonService.generateCBAUrl(purchasesUrl);
                objObservable = this._http
                    .get(purchasesUrl, httpOptions).pipe(catchError((error) => {
                    return of({ purchases: null, purchasesCount: 0 });
                }));
                break;
        }
        return objObservable;
    }
    getDotNetData() {
        let strUrl = window['AB']['gridDataURL'];
        switch (this.objGridData.drivenType) {
            case 'erumslastorder':
                let url = window['SWY']['CONFIGSERVICE'].erumsConfig['orders.service.endpoint'] + '/orders/latest';
                return this._http.get(url, {
                    headers: new HttpHeaders(window['AB']['lastOrderErumsHttpOptions'])
                }).pipe(catchError(() => of({ ack: true, products: [] })));
            case 'offer':
                const reqBody = this._prepareOfferParams();
                if (reqBody.data.length > 0) {
                    return this._http.post(strUrl + '?storeId=' + window['AB']['userInfo']['branchId'], reqBody);
                }
                else {
                    return of({ ack: true, products: [] });
                }
                break;
            case 'search':
                strUrl = this._replaceSearchValue(strUrl) + '&storeId=' + window['AB']['userInfo']['branchId'];
                return this._http.get(strUrl);
            case 'bogo':
            case 'rewardcard':
                break;
            case 'promo':
            case 'recipe':
            case 'dynamicpromo':
                strUrl += '&storeId=' + window['AB']['userInfo']['branchId'];
                return this._http.get(strUrl);
            case 'historylist':
                const strRand = (Math.floor((Math.random() * 1000000)));
                strUrl += '&rand=' + strRand + '&storeId=' + window['AB']['userInfo']['branchId'];
                return this._http.get(strUrl).pipe(catchError(() => of({ ack: true, products: [] })));
            default:
                return this._http.get(strUrl);
        }
    }
    getAllBrands() {
        const strUrl = this._replaceSearchValue(window['AB']['gridDataURLNoParam']);
        return this._http.get(strUrl);
    }
    getStaticData() {
        return of({
            'products': this.objGridData.products
        });
    }
    getUpdatedData(aisleId) {
        if (aisleId != null) {
            // delete last _number from aisleId since it comes as a sub-aisle of the aisle we need to make the request for
            aisleId = aisleId.slice(0, -2);
        }
        const url = window['AB']['aemAislePath'] + '?aisleId=' + aisleId + '&storeId=' + window['AB']['userInfo']['branchId'];
        // update analytics data layer, need to set the aisle id for the level 2 aisle page
        $(function () { window['AB']['DATALAYER'].productInfo({ aisleId: aisleId }); });
        return this._http.get(url);
    }
    hasDynamicData() {
        if (this.objGridData.drivenType === 'static') {
            return false;
        }
        else {
            if (window['AB']['gridDataURL'] || this.objGridData.apiUrl || this.objGridData.drivenType === 'relevancy') {
                return true;
            }
            else {
                return false;
            }
        }
    }
    hasBrandUrl() {
        return window['AB']['gridDataURLNoParam'] && window['AB']['gridDataURLNoParam'].length;
    }
    hasStaticData() {
        return this.objGridData.products.length > 0;
    }
    getNoResultsMsg(productGridPage) {
        let results;
        switch (productGridPage) {
            case 'shelf-page':
            case 'promo':
            case 'rewardcard':
            case 'bogo':
            case 'catalog':
            case 'erumslastorder':
            case 'historylastorder':
            case 'historylist':
                results = window['AB']['errorText'] || this.defaultNoResultsMsg;
                break;
            case 'search':
                results = `<div class='no-result'><div class=container'><dl>
                 <dd>Check for typos.</dd><dd>Be more general (e.g. \"carrots\" instead of \"bags of carrots\")</dd>
                 <dd>Try looking within the aisles shown below</dd>
                 </dl></div></div>`;
                break;
            default:
                results = '<span>No items are available.</span>';
                break;
        }
        return results;
    }
    extractBrand() {
        let result = Observable.create((obs) => {
            obs.next({ 'ack': true });
            obs.complete();
        });
        if (this.hasBrandUrl()) {
            result = this.getAllBrands();
        }
        return result;
    }
    areAllProductsUnavailable(products) {
        let isUnavailable = true;
        if (!Array.isArray(products)) {
            return false;
        }
        products.forEach((product) => {
            if (product.price !== 0) {
                isUnavailable = false;
            }
        });
        return isUnavailable;
    }
    _prepareOfferParams() {
        const offerId = window['AB']['offerId'];
        const arrUpc = this._commonService.getUpcByOffers(offerId);
        const arrParam = [];
        for (let index in arrUpc) {
            if (arrUpc.hasOwnProperty(index)) {
                arrParam.push({
                    'id': arrUpc[index]
                });
            }
        }
        return { 'data': arrParam };
    }
    _replaceSearchValue(strUrl) {
        let searchQuery = window['AB']['COMMON'].getURLParameterByName('q');
        if (searchQuery == null) {
            searchQuery = '';
        }
        else {
            searchQuery = decodeURIComponent(searchQuery);
            searchQuery = encodeURIComponent(searchQuery);
        }
        strUrl = strUrl.replace(/\(searchTerm\)/g, searchQuery);
        let searchBrand = window['AB']['COMMON'].getURLParameterByName('brand');
        if (searchBrand == null) {
            searchBrand = '';
        }
        else {
            searchBrand = decodeURIComponent(searchBrand);
            searchBrand = encodeURIComponent(searchBrand);
        }
        strUrl = strUrl.replace(/\(searchBrand\)/g, searchBrand);
        return strUrl;
    }
    getMoreSearchProducts(searchQuery, start, rows, fulfillmentType) {
        const searchProductsPath = this._config[this._currentEnv].searchProductsAPIDetails.searchProductsAPI;
        const basePath = this._config[this._currentEnv].baseURL.replace('{banner}', this._userInfoService.getBanner());
        const queryParams = {
            pageurl: basePath,
            url: basePath,
            "request-id": this._getUTCTimeStampRandom(),
            pagename: 'search',
            rows,
            start,
            'search-type': 'keyword',
            storeid: this._userInfoService.getShopStoreId(),
            q: searchQuery,
            dvid: 'GhXAoLXN-ss-search',
            channel: fulfillmentType,
            uuid: this._userInfoService.getUUID(),
            featured: false,
            banner: this._userInfoService.getBanner(),
            includeOffer: true
        };
        const queryParamsStr = Object.keys(queryParams).map(key => key + '=' + queryParams[key]).join('&');
        const url = `/${searchProductsPath}?${queryParamsStr}`;
        const httpOptions = {
            headers: new HttpHeaders({
                'ocp-apim-subscription-key': this._config[this._currentEnv].searchProductsAPIDetails.subscriptionKey.value,
                'accept': 'application/json'
            })
        };
        return this._http.get(url, httpOptions).pipe(map((searchResponseData) => {
            const returnObj = {
                products: searchResponseData?.['primaryProducts']?.['response']?.['docs'],
                offers: searchResponseData?.['offersData']
            };
            return returnObj;
        }), catchError(error => {
            return throwError(Error("Error in getting products"));
        }));
    }
    _getUTCTimeStampRandom() {
        return Math.floor(Math.random() * (999 - 100 + 1) + 100).toString() + Date.now() + Math.floor(Math.random() * (999 - 100 + 1) + 100).toString();
    }
    static { this.ɵfac = function ProductGenericGridALV1Service_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ProductGenericGridALV1Service)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ProductCatalogALV1Service), i0.ɵɵinject(i3.CommonService), i0.ɵɵinject(i3.UserInfoService), i0.ɵɵinject(i3.UtilService), i0.ɵɵinject(i3.P13nEndpointService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProductGenericGridALV1Service, factory: ProductGenericGridALV1Service.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductGenericGridALV1Service, [{
        type: Injectable
    }], () => [{ type: i1.HttpClient }, { type: ProductCatalogALV1Service }, { type: i3.CommonService }, { type: i3.UserInfoService }, { type: i3.UtilService }, { type: i3.P13nEndpointService }], null); })();

/**
 * Sort Service
 */
class SortALV1Service {
    initRules() {
        let results;
        results = {
            'a-z': {
                field: 'name',
                rule: [{ field: 'name', direction: 1, type: 'string' }],
                label: 'Alphabetical A - Z',
                sort_at: 'client'
            },
            'a-z-description': {
                field: 'description',
                rule: [{ field: 'description', direction: -1, type: 'string' }],
                label: 'Alphabetically',
                sort_at: 'client'
            },
            'z-a': {
                field: 'name',
                rule: [{ field: 'name', direction: -1, type: 'string' }],
                label: 'Alphabetical Z - A',
                sort_at: 'client'
            },
            'search-rank': {
                field: 'searchRank',
                rule: [
                    { field: 'searchRank', direction: -1, type: 'number' },
                    { field: 'name', direction: -1, type: 'string' }
                ],
                label: 'Search Ranking',
                sort_at: 'client'
            },
            'most-popular': {
                field: 'salesRank',
                rule: [
                    { field: 'salesRank', direction: 1, type: 'number' },
                    { field: 'name', direction: 1, type: 'string' }
                ],
                label: 'Most Popular',
                sort_at: 'client'
            },
            'price-low-high': {
                field: 'price',
                rule: [
                    { field: 'price', direction: 1, type: 'number' },
                    { field: 'name', direction: 1, type: 'string' }
                ],
                label: 'Price - Low to High',
                sort_at: 'client'
            },
            'purchase-history': {
                field: 'purchaseRank',
                rule: [
                    { field: 'purchaseRank', direction: -1, type: 'string' }
                ],
                label: 'Purchase History',
                sort_at: 'client'
            },
            'new-offers': {
                field: 'arrivalRank',
                rule: [
                    { field: 'arrivalRank', direction: 1, type: 'string' }
                ],
                label: 'New Offers',
                sort_at: 'client'
            },
            'about-to-expire': {
                field: 'expiryRank',
                rule: [
                    { field: 'expiryRank', direction: 1, type: 'string' }
                ],
                label: 'About to Expire',
                sort_at: 'client'
            },
            'category': {
                field: 'categoryId',
                rule: [
                    { field: 'categoryId', direction: 1, type: 'string' }
                ],
                label: 'Category',
                sort_at: 'client'
            },
            'expiry-date': {
                field: 'endDate',
                rule: [
                    { field: 'endDate', direction: 1, type: 'string' }
                ],
                label: 'Expiry Date',
                sort_at: 'client'
            },
            'added-date': {
                field: 'addedDate',
                rule: [
                    { field: 'addedDate', direction: 1, type: 'string' }
                ],
                label: 'Added Date',
                sort_at: 'client'
            },
            'reward-card-specials': {
                field: 'promoDescription',
                rule: [
                    {
                        field: 'promoDescription',
                        direction: -1,
                        type: 'custom',
                        callback: (tempA, sort) => {
                            if (this.isPromoMatch(tempA[sort.field])) {
                                return 'AAA';
                            }
                            else {
                                return 'ZZZ';
                            }
                        }
                    },
                    { field: 'name', direction: -1, type: 'string' }
                ],
                label: this._commonService.getPromoDescription(),
                sort_at: 'client'
            },
            aisles: {
                // dummy, needs to be here for now for backwards compatibility
                field: 'groupByTemplate',
                rule: [],
                label: 'Aisles',
                sort_at: 'client'
            },
            aisles_departmentName: {
                field: 'departmentName',
                rule: [
                    { field: 'departmentName', direction: -1, type: 'string' },
                    { field: 'name', direction: -1, type: 'string' }
                ],
                label: 'Aisles',
                sort_at: 'client'
            },
            aisles_aisleName: {
                field: 'aisleName',
                rule: [
                    { field: 'aisleName', direction: -1, type: 'string' },
                    { field: 'name', direction: -1, type: 'string' }
                ],
                label: 'Aisles',
                sort_at: 'client'
            },
            aisles_shelfName: {
                field: 'shelfName',
                rule: [
                    { field: 'shelfName', direction: -1, type: 'string' },
                    { field: 'name', direction: -1, type: 'string' }
                ],
                label: 'Aisles',
                sort_at: 'client'
            },
            'bloomreach-top-sellers': {
                field: 'salesRank+asc',
                rule: null,
                label: 'Top sellers',
                sort_at: 'server'
            },
            'bloomreach-price-low-high': {
                field: 'price+asc',
                rule: null,
                label: 'Price low to high',
                sort_at: 'server'
            },
            'bloomreach-best-match': {
                field: '',
                rule: null,
                label: 'Best Match',
                sort_at: 'server'
            },
            'bloomreach-club-card': {
                field: 'promoType+asc',
                rule: null,
                label: this._commonService.getPromoDescription(),
                sort_at: 'server'
            },
            aisles_coupons: {
                // dummy, needs to be here for now for backwards compatibility
                field: 'purchaseInd',
                rule: [{ field: 'purchaseInd', direction: -1, type: 'string' }],
                label: 'Type of Coupons',
                sort_at: 'client'
            },
            FREQUENCY: {
                field: 'FREQUENCY',
                rule: null,
                label: 'Frequently Purchased',
                sort_at: 'server'
            },
            PURCHASE_DATE: {
                field: 'PURCHASE_DATE',
                rule: null,
                label: 'Purchase Date',
                sort_at: 'server'
            },
            RECOMMENDED: {
                field: 'RECOMMENDED',
                rule: null,
                label: 'Recommended',
                sort_at: 'server'
            },
            RECENTLY_PURCHASED: {
                field: 'PURCHASE_DATE',
                rule: null,
                label: 'Recently Purchased',
                sort_at: 'server'
            }
        };
        return results;
    }
    isPromoMatch(label) {
        const promoRules = this._commonService.getPromorulesArray();
        if (!promoRules || promoRules.length === 0) {
            return false;
        }
        let found = false;
        promoRules.forEach(function (promoRule) {
            if (label && label.length > 0) {
                if (label.match(promoRule['rule'])) {
                    found = true;
                }
            }
        });
        return found;
    }
    constructor(_commonService) {
        this._commonService = _commonService;
        this.sorts = new Array();
        this.rules = this.initRules();
        this.available = window['AB']['availableSorts'] || [];
        if (this.hasSort()) {
            this.generate();
        }
    }
    setAvailableSort(sort) {
        this.available = sort;
    }
    getDefaultSort() {
        if (this.default) {
            return this.default;
        }
        if (this.available.filter(rule => rule === 'a-z').length > 0) {
            this.default = this.getSortByName('a-z');
        }
        else {
            this.default = this.available[0] ? this.getSortByName(this.available[0]) : this.getSortByName('a-z');
        }
        return this.default;
    }
    getDefaultSortForConfigurableSort(defaultRule) {
        if (this.available.filter(rule => rule === defaultRule).length > 0) {
            this.default = this.getSortByName(defaultRule);
        }
        else {
            this.default = this.available[0] ? this.getSortByName(this.available[0]) : this.getSortByName(defaultRule);
        }
        return this.default;
    }
    hasSort() {
        return !!this.available.length;
    }
    getSortByName(name) {
        return this.rules[name];
    }
    /**
    * Given a comma-delimited string of sort names, return the collection of SortModels
    */
    getSortOptions(sortValues) {
        let sortOptions = [];
        if (sortValues) {
            // Break up the comma-delimited collection into an array
            let valueCollection = sortValues.split(',');
            // Iterate over each specified sort name, looking it up in the collection of rule and
            // if found, append it to the returned SortModel collection
            valueCollection.forEach((sortName, index) => {
                const sortRule = this.getSortByName(sortName.trim());
                if (sortRule)
                    sortOptions.push(new SortModel(sortRule));
            });
        }
        return sortOptions;
    }
    getSorts() {
        return this.sorts;
    }
    sortBy(collection, iteratees, orderArray = 'asc') {
        // Ensure iteratees is an array
        const iteratesArray = Array.isArray(iteratees) ? iteratees : [iteratees];
        // Normalize order to an array: if it's a single value, make it an array
        const order = Array.isArray(orderArray) ? orderArray : [orderArray];
        return [...collection].sort((a, b) => {
            for (let i = 0; i < iteratesArray.length; i++) {
                const iteratee = iteratesArray[i];
                const aValue = typeof iteratee === 'function' ? iteratee(a) : a[iteratee];
                const bValue = typeof iteratee === 'function' ? iteratee(b) : b[iteratee];
                if (aValue < bValue) {
                    return order[i] === 'asc' ? -1 : 1;
                }
                else if (aValue > bValue) {
                    return order[i] === 'asc' ? 1 : -1;
                }
            }
            return 0;
        });
    }
    sort(sort, data) {
        const sortByCriteria = sort && sort.rule ? sort.rule.map(rule => {
            return (a) => {
                const tempA = Object.assign({}, a);
                if (rule.type === 'string') {
                    if (tempA && tempA[rule.field]) {
                        tempA[rule.field] = tempA[rule.field].toString().toLowerCase();
                    }
                }
                if (rule.type === 'number') {
                    tempA[rule.field] = parseFloat(tempA[rule.field]);
                }
                if (rule.type === 'custom') {
                    return rule.callback.call(this, tempA, sort);
                }
                return tempA[rule.field];
            };
        }) : '';
        const sortByDirection = sort && sort.rule ? sort.rule.map(rule => {
            if (rule.direction === 1) {
                return 'asc';
            }
            return 'desc';
        }) : '';
        return this.sortBy(data, sortByCriteria, sortByDirection);
    }
    couponsSort(sort, data) {
        const sortByCriteria = sort.rule.map(rule => {
            return (a) => {
                const tempA = Object.assign({}, a);
                if (rule.type === 'string') {
                    if (tempA && tempA[rule.field]) {
                        tempA[rule.field] = tempA[rule.field].toString().toLowerCase();
                    }
                }
                if (rule.type === 'number') {
                    tempA[rule.field] = parseFloat(tempA[rule.field]);
                }
                if (rule.type === 'custom') {
                    return rule.callback.call(this, tempA, sort);
                }
                return tempA[rule.field];
            };
        });
        const sortByDirection = sort.rule.map(rule => {
            if (rule.direction === 1) {
                return 'asc';
            }
            return 'desc';
        });
        return this.sortBy(data, sortByCriteria, sortByDirection);
    }
    generate() {
        if (this.available.length === 0) {
            return;
        }
        this.sorts = [];
        this.available.forEach((type, index) => {
            const rule = this.rules[type];
            if (!rule) {
                return;
            }
            /* overwrite with custom group by rule based on headerType setting */
            if (rule.field === 'groupByTemplate') {
                const groupByRuleKey = 'aisles' + '_' + window['AB']['headerType'];
                rule.rule = this.rules[groupByRuleKey] ? this.rules[groupByRuleKey].rule : '';
            }
            this.sorts.push(new SortModel(rule));
            if (this.default === undefined && type === window['AB']['defaultSort']) {
                this.default = rule;
            }
        });
    }
    static { this.ɵfac = function SortALV1Service_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SortALV1Service)(i0.ɵɵinject(i3.CommonService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SortALV1Service, factory: SortALV1Service.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SortALV1Service, [{
        type: Injectable
    }], () => [{ type: i3.CommonService }], null); })();

/**
 * Product Generic Grid - Master Product Grid
 *
 * @template <product-generic-grid-al-v1>
 */
const _c0 = a0 => ({ "no-results": true, "search-no-results": a0 });
const _c1 = a0 => ({ "pc-grid-contained": a0 });
const _c2 = a0 => ({ "bia-sort": a0 });
function ProductGenericGridALV1Component_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "div", 5)(2, "div", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0, ctx_r0.searchNoResults));
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.noResults, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.aisleHTML, i0.ɵɵsanitizeHtml);
} }
function ProductGenericGridALV1Component_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, ProductGenericGridALV1Component_div_0_div_1_Template, 3, 5, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showGrid);
} }
function ProductGenericGridALV1Component_div_1_sort_by_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sort-by", 15);
    i0.ɵɵlistener("activeSortRuleEmitter", function ProductGenericGridALV1Component_div_1_sort_by_1_Template_sort_by_activeSortRuleEmitter_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.activeSortRuleEmitter($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("sortRules", ctx_r0.sortRules)("activeSortRule", ctx_r0.activeSortRule)("ngClass", i0.ɵɵpureFunction1(3, _c2, ctx_r0.biaSort));
} }
function ProductGenericGridALV1Component_div_1_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "h2");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const product_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(product_r3[ctx_r0.groupByField]);
} }
function ProductGenericGridALV1Component_div_1_ng_container_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "product-item-al-v2", 19);
    i0.ɵɵtwoWayListener("isRestrictedChange", function ProductGenericGridALV1Component_div_1_ng_container_3_ng_container_2_Template_product_item_al_v2_isRestrictedChange_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(3); i0.ɵɵtwoWayBindingSet(ctx_r0.unAttendDeliveryFlag, $event) || (ctx_r0.unAttendDeliveryFlag = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const product_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("isRestricted", ctx_r0.unAttendDeliveryFlag);
    i0.ɵɵproperty("data", product_r3)("offers", ctx_r0.dataOffers)("calledBy", ctx_r0.calledBy)("configObj", ctx_r0.configObj)("isCalledByRightDrawerOrSns", ctx_r0.isCalledByRightDrawerOrSns);
} }
function ProductGenericGridALV1Component_div_1_ng_container_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 10)(2, "div", 20)(3, "span", 21);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "div", 22);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    let tmp_5_0;
    const i_r5 = i0.ɵɵnextContext().index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", (tmp_5_0 = ctx_r0.gridCarousels.get(ctx_r0.fullWidthIndicies.get(i_r5))) == null ? null : tmp_5_0.carouselTitle, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", "gridZoneContent" + i_r5);
} }
function ProductGenericGridALV1Component_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductGenericGridALV1Component_div_1_ng_container_3_div_1_Template, 3, 1, "div", 16)(2, ProductGenericGridALV1Component_div_1_ng_container_3_ng_container_2_Template, 2, 6, "ng-container", 17)(3, ProductGenericGridALV1Component_div_1_ng_container_3_ng_container_3_Template, 6, 2, "ng-container", 17);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const product_r3 = ctx.$implicit;
    const i_r5 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", product_r3.isGroupSplit && ctx_r0.isAisleSort && ctx_r0.loadSort());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.fullWidthIndicies.has(i_r5));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.gridCarousels.size > 0 && ctx_r0.fullWidthIndicies.has(i_r5));
} }
function ProductGenericGridALV1Component_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "button", 24);
    i0.ɵɵlistener("click", function ProductGenericGridALV1Component_div_1_div_7_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r6); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.loadMoreProducts("grid_button")); });
    i0.ɵɵtext(2, "Load more");
    i0.ɵɵelementEnd()();
} }
function ProductGenericGridALV1Component_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25)(1, "div", 26)(2, "div", 27)(3, "div", 28);
    i0.ɵɵelement(4, "div", 29);
    i0.ɵɵelementEnd()()()();
} }
function ProductGenericGridALV1Component_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30)(1, "button", 31);
    i0.ɵɵlistener("click", function ProductGenericGridALV1Component_div_1_div_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r7); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.loadMoreProductsServerSide("grid_button")); });
    i0.ɵɵtext(2, "Load more");
    i0.ɵɵelementEnd()();
} }
function ProductGenericGridALV1Component_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, ProductGenericGridALV1Component_div_1_sort_by_1_Template, 1, 5, "sort-by", 7);
    i0.ɵɵelementStart(2, "div", 8);
    i0.ɵɵtemplate(3, ProductGenericGridALV1Component_div_1_ng_container_3_Template, 4, 3, "ng-container", 9);
    i0.ɵɵelement(4, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 11);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, ProductGenericGridALV1Component_div_1_div_7_Template, 3, 0, "div", 12)(8, ProductGenericGridALV1Component_div_1_div_8_Template, 5, 0, "div", 13)(9, ProductGenericGridALV1Component_div_1_div_9_Template, 3, 0, "div", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.products.length > 0 && ctx_r0.hasSort && ctx_r0.loadSort());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1, ctx_r0.isCalledByRightDrawerOrSns));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.products);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.afbEvent);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.component.pagination.load_type == "loadmore" && !ctx_r0.isServerGridLoading && (ctx_r0.products.length < ctx_r0.productsSecondary.length || ctx_r0.isOneTimeSns && ctx_r0.numOfReceivedProducts >= 30 && ctx_r0.searchKeyword.length > 0));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isServerGridLoading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.hasServerSideLoadMore && !ctx_r0.isServerGridLoading);
} }
class ProductGenericGridALV1Component {
    set replacementProducts(products) {
        // Skip on first initialization of component. 
        if (this.objGridData?.usesDynamicGridWrapper !== true)
            return;
        // Products passed in will be null on initialization of component.
        if (products === null || products === undefined)
            return;
        if (products.length == 0) {
            this._processNoData();
            return;
        }
        this.products = products;
        this.calculateProductsPerRowInPCRedesign();
    }
    set additionalProducts(products) {
        if (this.objGridData?.usesDynamicGridWrapper !== true)
            return;
        if (products === null || products === undefined)
            return;
        if (products.length == 0) {
            this._processNoData();
            return;
        }
        this.products = this.products.concat(products);
        this.calculateProductsPerRowInPCRedesign();
        // Chunk products and add to existing. 
        // Then focus onto the new products. 
    }
    constructor(_productGridService, _http, zone, elementRef, _commonService, _userInfoService, _aemService, _sortService, _cartService, _dataScrollService, _productFilterService, _loaderService) {
        this._productGridService = _productGridService;
        this._http = _http;
        this.elementRef = elementRef;
        this._commonService = _commonService;
        this._userInfoService = _userInfoService;
        this._aemService = _aemService;
        this._sortService = _sortService;
        this._cartService = _cartService;
        this._dataScrollService = _dataScrollService;
        this._productFilterService = _productFilterService;
        this._loaderService = _loaderService;
        this.gridCarousels = new Map();
        this.config = EnviormentConfig;
        this.pTime = new Date();
        this.notAvailableDisp = ['historylastorder', 'historylist', 'purchase'];
        // Infinite scroll variables
        this.infiniteScrollPage = 1;
        this._isServerLoadMoreTriggered = false;
        this.products = [];
        this.initialProducts = [];
        this.productsSecondary = [];
        this.ack = true;
        this.showGrouping = 'mask';
        this.filterAisleParam = '';
        this.filterBrandParam = '';
        this.isFilter = false;
        this.noResults = '';
        this.displayNoResults = false;
        this.aisleHTML = '';
        this.groupByField = window['AB']['headerType'] || 'departmentName';
        this.currentGroupBy = '';
        this.groupByHeadingField = '';
        this.isGroupInit = false;
        this.isAisleSort = false;
        this.allowNotAvailable = false;
        this.areAllProductsUnavailable = false;
        this.unAttendDeliveryFlag = false;
        this.afbEvent = '';
        this.showBackToTopButton = false;
        this.totalProducts = 0;
        this.searchNoResults = false;
        this.productColumnClass = 'col-12 col-sm-6 col-lg-4';
        this.productColumnClassV2 = 'col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3';
        this.component = {};
        this.dataOffers = {};
        //Total number of received products from search api or sns data attribute
        this.numOfReceivedProducts = 0;
        this.biaSort = false;
        this.showAddAllItemsBtn = false;
        this.arProductsArray = [];
        this.enableDSTV2Theme = false;
        // README: Flag used for displaying the load-more elements for the client side product functionality.
        this.hasServerSideLoadMore = false;
        this.isServerGridLoading = false;
        this.isArEnable = false;
        this.snsFulfillmentType = '';
        this.isCalledByRightDrawerOrSns = false;
        this.isOneTimeSns = false;
        this.searchKeyword = '';
        this.subscription = new Subscription();
        this.productsPerRowInPCRedesign = 0;
        this.fullWidthIndicies = new Map();
        /**
         * Checks any product in grid row is arEnabled or not
         */
        this.checkAnyProductHasAddlInfo = (products) => !!products ? products.some(product => (product?.isArProduct && this.isArEnable) || product?.isMarketplaceItem == 'Y') : false;
        this.wrapperName = 'targeted-wrapper';
        this.wrapperAttribute = 'data-targeted-component';
        if (window?.['AB']?.['userInfo'] && !this._userInfoService.getUserSession()) {
            this._userInfoService.initUserSession();
        }
        this._componentElement = this.elementRef.nativeElement;
        //Check if theme builder is enabled
        //this.isThemeBuilderEnabled = window['SWY']['CONFIGSERVICE'] && window['SWY']['CONFIGSERVICE'].isThemeBuilderEnabled ? true : false;
        this.isThemeBuilderEnabled = false;
        this.calcTime('START');
        this.showGrid = true;
        // Save component as global to extend its accessibility.
        window['productGenericGridCompRef'] = { zone: zone, component: this };
        this.enableDSTV2Theme = this._commonService.hasPageV2Theme();
    }
    ngOnInit() {
        this.isCalledByRightDrawerOrSns = this.calledBy === 'c-products-by-upc-drawer' || this.calledBy === 's-bogo';
        const jsonConfigObj = this._componentElement.getAttribute('data-configObj');
        if (jsonConfigObj && this.configObj === undefined) {
            this.configObj = JSON.parse(jsonConfigObj);
            if (this.configObj.programType === '1P_SNS') {
                this.setSnsOneTimeData();
            }
        }
        localStorage.setItem('productGenericGridData', JSON.stringify(this.objGridData));
        this.component = {
            pagination: {
                load_type: this.objGridData?.load_type,
                load_items: this._getLoadMoreItems(),
                infinite_type: this.objGridData?.infinite_type,
                paginate_at: this.objGridData.apiType === 'buy-it-again' ? 'server' : 'client',
                page: 1,
            }
        };
        // get products that are passed in from wrapper component
        if (this.qualifiedProducts) {
            this.qualifiedProducts = JSON.parse(this.qualifiedProducts);
            if (this.isOneTimeSns && this.qualifiedProducts?.products?.length) {
                this.qualifiedProducts.products = this.filterSnsNextOrderBpns(this.qualifiedProducts.products);
            }
            this.numOfReceivedProducts = this.qualifiedProducts?.products?.length ?? 0;
        }
        else {
            this.qualifiedProducts = null;
        }
        // set data offers for snsOneTime 
        const dataOffers = this._componentElement.getAttribute('data-offers');
        if (dataOffers) {
            this.dataOffers = JSON.parse(dataOffers);
        }
        this.hasSort = this._sortService.hasSort();
        this.sortRules = this._sortService.getSorts();
        this.sortRules = this.sortRules?.filter(rule => rule.label !== 'Search Ranking');
        this.products = [];
        this.calculateProductsPerRowInPCRedesign();
        this.calcTime('INIT');
        this.noResults = this._productGridService.getNoResultsMsg(this.productGridPage);
        this.allowNotAvailable = (this.notAvailableDisp.indexOf(this.productGridPage) !== -1) ? true : false;
        this.configObj?.appName === "cart" ? this.allowNotAvailable = true : this.allowNotAvailable;
        this.productColumnClass = this.objGridData.apiType === 'c-products-by-upc' || this.productGridPage === 'offer'
            ? 'col-12 col-sm-6 col-md-4 col-lg-3'
            : this.productColumnClass;
        if (!(this.objGridData.doGenericFlow === true || this.objGridData?.usesDynamicGridWrapper === true)) {
            this.productColumnClassV2 = this.objGridData.apiType === 'c-products-by-upc' || this.productGridPage === 'offer' ||
                this.objGridData.apiType === 'c-products-by-upc-drawer' || this.objGridData.apiType === 's-bogo'
                ? 'col-6 col-sm-6 col-md-3 col-lg-2 col-xl-2'
                : this.productColumnClassV2;
        }
        this.calcTime('INIT');
        this.calcTime('REQUESTED DATA');
        this._productGridService.objGridData = this.objGridData;
        localStorage.setItem('productGenericGridData', JSON.stringify(this.objGridData));
        if (this.productGridPage === 'erumslastorder'
            || this.productGridPage === 'historylist'
            || this.productGridPage === 'purchase') {
            this._commonService.userInfoRefresh.subscribe(data => {
                if (data === 'initFunc') {
                    this._getResults();
                }
            });
        }
        else {
            this._getResults();
            if (this.objGridData.apiType === 'c-products-by-upc') {
                this._commonService.shopCouponRefresh.subscribe(isRefresh => {
                    if (isRefresh) {
                        this._init();
                    }
                });
            }
        }
        // check if any qualified products are already in cart - show correct UI state if so
        let _currentCart = this._cartService._get();
        if (this._commonService.isEmpty(_currentCart)) {
            // load remote cart object - will handle refresh of products that are present in cart already
            this._cartService._loadERUMSRemoteCart();
        }
        else {
            this._commonService._cartObjSource.next(_currentCart);
        }
    }
    setSnsOneTimeData() {
        this.qualifiedProducts = this._componentElement.getAttribute('data-products');
        this.isOneTimeSns = true;
        this.isCalledByRightDrawerOrSns = true;
        this.searchKeyword = this.configObj['data-search-key'];
        this.snsFulfillmentType = this.configObj['data-fulfillment-channel'];
        const attributes = this._componentElement.attributes;
        this.objGridData = {
            drivenType: "catalog",
            apiUrl: '',
            apiType: '',
            sorts: false,
            defaultSort: undefined,
            value: {},
            products: [],
            widgetId: false,
            load_type: attributes['data-load-type']?.value ?? 'loadmore',
            infinite_type: attributes['data-infinite-scroll-type']?.value ?? 'client'
        };
    }
    _getResults() {
        // We should wait until AR flag (true/false) is resolved/loaded 
        // then trigger xAPI to get the products
        // if(window['AB']['arFlagLoaded']){
        if (this._aemService.isArFlagLoaded()) {
            this.isArEnable = this._aemService.getArFlag()?.display;
            console.warn('== PRODUCT GENERIC GRID DECIDED isArEnable property in the component');
            this._init();
        }
        else if (this._commonService.canTriggerProductsCall()) {
            this.subscription.add(fromEvent(document, 'arFlagLoaded').subscribe(event => {
                this.isArEnable = event && event['detail'] && event['detail']['arFlag'] ? event['detail']['arFlag']['display'] : false;
                console.warn('== PRODUCT GENERIC GRID RECEIVED EVENT AND NOW IS READY TO MAKE PRODUCTS CALL');
                this._init();
            }));
        }
        else {
            this._init();
        }
    }
    _init() {
        // Get products in this.products to show in template
        if (this.qualifiedProducts != null) {
            if ((this.qualifiedProducts.ack == false || this.isOneTimeSns) && this.qualifiedProducts.products && this.qualifiedProducts.products.length > 0) {
                const observeData = new Observable((obs) => {
                    obs.next(this.qualifiedProducts);
                    obs.complete();
                });
                this.calcTime('RECEIVED DATA');
                observeData.subscribe({ next: (productsData) => {
                        switch (this.objGridData.drivenType) {
                            case 'purchase':
                                switch (this.objGridData.apiType) {
                                    case 'buy-it-again':
                                        // README: Set active sort rule
                                        this.activeSortRule = this.objGridData.value.sortRule;
                                        break;
                                    default:
                                        // Get default sort rule
                                        this.activeSortRule = this._sortService.getDefaultSort();
                                        break;
                                }
                                break;
                            default:
                                // Get default sort rule
                                this.activeSortRule = this._sortService.getDefaultSort();
                                break;
                        }
                        // send products data to add-all-button component
                        this._sendProductsToAddAllComponent(productsData);
                        // Get all departments from products
                        for (const product of productsData.products) {
                            this._productFilterService.addDepartment(product['departmentName']);
                        }
                        // Check if filter is enabled and filter products by aisle
                        if (this.isFilter === true) {
                            productsData.products = productsData.products.filter(product => this._doFilter(product));
                        }
                        // Filter products with price 0 when allowNotAvailable is true
                        if (!this.allowNotAvailable) {
                            productsData.products = productsData.products.filter(p => (p.price > 0.00 && p.price != null));
                        }
                        // Pagination.
                        /* The below condition is to handle grid to load only initial set of products of the newly selected department
                           when a user switches from the previous department load-more products */
                        this.component.pagination.page = 1;
                        this._pagination(productsData);
                        this.checkAvailability(productsData.products);
                        // AR Project
                        this.arProductsArray = this.chunkArray([...productsData.products] || []);
                        this.calcTime('PROCESSED DATA');
                        // Count and show custom text for search page
                        this.searchResult(this.totalProducts);
                        // Subscribe to back to top button scroll event
                        this._dataScrollService.backToTopScroll$.subscribe(scrollY => this.showBackToTopButton = (scrollY > window.innerHeight));
                        if ((this.objGridData.apiType === 'c-bogo' || this.productGridPage === 'bogo') && $('.bogo--paragraph') != null) {
                            $('.bogo--paragraph').removeClass('mask');
                            $('.bogo--error').addClass('mask');
                        }
                        if (typeof productsData.brands !== 'undefined' && productsData.brands != null) {
                            for (const brand of productsData.brands) {
                                this._productFilterService.addBrand(brand);
                            }
                        }
                        else if (this.productGridPage === 'search') {
                            const obsBrand = this._productGridService.extractBrand();
                            obsBrand.subscribe((brandsData) => {
                                if (typeof brandsData.brands !== 'undefined' && brandsData.brands != null) {
                                    for (const brand of brandsData.brands) {
                                        this._productFilterService.addBrand(brand);
                                    }
                                }
                            });
                        }
                    }, error: (err) => {
                        this._processNoData();
                    } });
            }
            else {
                this._processNoData();
            }
            // README: Reset server load-more flags
            this._isServerLoadMoreTriggered = false;
            setTimeout(() => { this.showGrid = true; $('#loadingConMedium').hide(); }, 10);
            this.calcTime('END');
        }
        else {
            this._processNoData();
        }
    }
    /**
     * Handle pagination with load more, infinite scroll or none.
     */
    _pagination(productsArray) {
        if (this.component.pagination.load_type === 'loadmore') {
            if (this.component.pagination.paginate_at === 'client') {
                const hasProducts = productsArray.products != null && productsArray.products !== '';
                //Do sorting for pages which are not driven by relelvancy
                if (this.productGridPage !== 'relevancy') {
                    // Load more pagination.
                    this.productsSecondary = hasProducts ? this.doSort(productsArray.products) : [];
                }
                else {
                    this.productsSecondary = hasProducts ? productsArray.products : [];
                }
                this.loadMoreProducts();
            }
            else if (this.component.pagination.paginate_at === 'server'
                && productsArray.products != null
                && productsArray.products !== '') {
                // README: Store new products
                this.products.push(...productsArray.products);
                // README: Validate load-more button
                this.hasServerSideLoadMore = this.products.length >= this._getLoadMoreItems() ? true : false;
                // README: Move focus to new items
                if (this._serverNewItemToFocus
                    && this.products[this._serverNewItemToFocus]
                    && this.products[this._serverNewItemToFocus].id) {
                    const newID = '.product-title#pg' + this.products[this._serverNewItemToFocus].id;
                    $(newID).ready(() => $(newID).focus());
                }
            }
        }
        else if (this.component.pagination.load_type === 'infinitescroll' && this.component.pagination.infinite_type === 'client') {
            // We have infinite scroll Client pagination
            this.infiniteScroll(productsArray);
        }
        else if (this.component.pagination.load_type === 'infinitescroll' && this.component.pagination.infinite_type === 'server') {
            // We have infinite scroll Server pagination
            // TODO: Will be resolved with client pagination
            this.infiniteScroll(productsArray);
        }
        else {
            // We don't have any pagination, load all products
            this.products = (productsArray.products != null && productsArray.products !== '') ? productsArray.products : [];
            this.totalProducts = this.products.length;
            // Sort all products with default rule, except those on search and relevancy pages
            if (this.productGridPage !== 'search' && this.productGridPage !== 'relevancy') {
                this.doSort();
            }
        }
        this.calculateProductsPerRowInPCRedesign();
    }
    ngAfterViewInit() {
        this.calcTime('VIEW Init');
        if (window['AB'] && window['AB']['DATALAYER'] && this.calledBy === 'p13n') {
            window['AB']['DATALAYER'].trackP13nGrid(this.elementRef.nativeElement, this.qualifiedProducts);
        }
    }
    checkAvailability(products) {
        this.areAllProductsUnavailable = this._productGridService.areAllProductsUnavailable(products);
    }
    calcTime(msg) {
        const curTime = new Date();
        const pStrTime = this.pTime.getHours()
            + ':' + this.pTime.getMinutes()
            + ':' + this.pTime.getSeconds()
            + ':' + this.pTime.getMilliseconds();
        const curStrTime = curTime.getHours() + ':' + curTime.getMinutes() + ':' + curTime.getSeconds() + ':' + curTime.getMilliseconds();
    }
    getCart() {
        let cartUrl = window['AB']['miniCartPath'];
        if (this._aemService.getOrderNumberCookie() !== '') {
            cartUrl += '?id=' + this._aemService.getOrderNumberCookie();
        }
        return this._http.get(cartUrl);
    }
    _doFilter(product) {
        let result = true;
        result = window['AB']['COMMON'].getURLParameterByName('aisle')
            && (product['departmentName'] === this.filterAisleParam);
        return result;
    }
    hasGroupHeading() {
        if (this.hasSort && this.isAisleSort && !this.isGroupInit) {
            this.isGroupInit = true;
            this.products.forEach((prod) => {
                if (prod[this.groupByField] !== this.currentGroupBy) {
                    this.currentGroupBy = prod[this.groupByField];
                    prod['isGroupSplit'] = true;
                }
            });
        }
    }
    /**
     * Sort products from view or sort optional array if passed in parameter
     *
     * @param {any} sortAnything is optional, may contains temp product array
     * @returns with sortAnything will returns the sorter array
     */
    doSort(sortAnything) {
        // README: reset this value in order to properly display group heading when sorting by Aisles
        this.currentGroupBy = '';
        this.products.forEach(product => {
            if (product.hasOwnProperty('isGroupSplit')) {
                delete product['isGroupSplit'];
            }
        });
        this.isGroupInit = false;
        if (sortAnything) {
            // Sort the optional parameter and returns sorted array
            // if program type is 1P _SNS do not sort results
            return this.configObj.programType === '1P_SNS' ? sortAnything : this._sortService.sort(this.activeSortRule, sortAnything);
        }
        else if (this.component.pagination.load_type === 'loadmore') {
            if (!this.component.pagination.paginate_at || this.component.pagination.paginate_at === 'client') {
                // Sort for load more pagination
                // if program type is 1P _SNS do not sort results
                this.productsSecondary = this.configObj.programType === '1P_SNS'
                    ? this.productsSecondary : this._sortService.sort(this.activeSortRule, this.productsSecondary);
                this.productsSecondary = this._sortProductsByDepartmentName(this.productsSecondary);
                this.products = this.productsSecondary.slice(0, this.component.pagination.load_items * this.component.pagination.page);
            }
            else if (this.component.pagination.paginate_at && this.component.pagination.paginate_at === 'server') {
                // README: Clear products array because the sort result starts from the beginning
                this.products = [];
                // REDME: Launch api call
                this._init();
            }
        }
        else if (this.component.pagination.load_type === 'infinitescroll' && this.component.pagination.infinite_type === 'client') {
            // Sort custom when infinite scroll on client side is activated
            // if program type is 1P _SNS do not sort results
            this.productsSecondary = this.configObj.programType === '1P_SNS' ?
                this.productsSecondary : this._sortService.sort(this.activeSortRule, this.productsSecondary);
            this.productsSecondary = this._sortProductsByDepartmentName(this.productsSecondary);
            this.products = this.productsSecondary.slice(0, this.infiniteScrollItems * this.infiniteScrollPage);
        }
        else {
            // Default: sort the products from viewport
            this.products = this._sortProductsByDepartmentName(this.products);
            // if program type is 1P _SNS do not sort results
            this.products = this.configObj.programType === '1P_SNS'
                ? this.products : this._sortService.sort(this.activeSortRule, this.products);
        }
        this.isAisleSort = this.activeSortRule && this.activeSortRule.field === this._sortService.getSortByName('aisles').field;
        this.hasGroupHeading();
        this.calculateProductsPerRowInPCRedesign();
    }
    /**
     * Method sorting products by departmentName prop. This method groups the products by department and is used by the aisle sort rule.
     */
    _sortProductsByDepartmentName(products) {
        let sortedProducts = products;
        // README: Sory by detpartmentName only if sort rule is 'Aisles'
        if (this.activeSortRule?.label === 'Aisles') {
            const compareDepartmentNames = (a, b) => {
                return a.departmentName < b.departmentName ? -1 : 1;
            };
            sortedProducts = products ? products.sort(compareDepartmentNames) : products;
        }
        return sortedProducts;
    }
    activeSortRuleEmitter(activeSortRule) {
        this.activeSortRule = activeSortRule;
        switch (this.objGridData.drivenType) {
            case 'purchase':
                switch (this.objGridData.apiType) {
                    case 'buy-it-again':
                        // README: Save selected sort rule for api call object
                        this.objGridData.value.sortRule = this.activeSortRule;
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
        this.doSort();
    }
    searchResult(searchNrResults) {
        const currentTitle = document.querySelector('#searchNrResults');
        if (this.productGridPage === 'search' && currentTitle) {
            const searchQuery = window['AB']['COMMON'].getURLParameterByName('q');
            if (searchNrResults > 0) {
                currentTitle.innerHTML = searchNrResults + ' results for <b>' + searchQuery + '</b>';
            }
            else {
                if (searchQuery != null) {
                    currentTitle.innerText = 'No results for "' + searchQuery + '"';
                }
                else {
                    currentTitle.innerText = 'No results found.';
                }
                this.searchNoResults = true;
                document.querySelector('.asidediv.col-md-9').classList.remove('col-md-9');
                document.querySelector('.asidediv').classList.add('col-md-12');
            }
            window['AB']['DATALAYER'].updateSearch(searchQuery, searchNrResults);
        }
    }
    /**
     * Init infinite scroll pagination
     *
     * @param {any} data comming from api call, contains products
     */
    infiniteScroll(data) {
        // Get all products in productsSecondary array and sort them with default rule
        this.productsSecondary = (data.products != null && data.products !== '') ? this.doSort(data.products) : [];
        this.infiniteScrollItems = this._dataScrollService.getNumberOfItems();
        this.totalProducts = this.productsSecondary.length;
        this.hideLoader();
        // Filter products with price 0 when allowNotAvailable is true
        if (!this.allowNotAvailable) {
            this.productsSecondary = this.productsSecondary.filter(p => (p.price > 0.00 && p.price != null));
        }
        // Filter case when are lower products than minimum required per infinite scrolling page
        if (this.productsSecondary.length <= this.infiniteScrollItems) {
            this.products = this.productsSecondary;
            this.doSort();
            return;
        }
        // Subscribe to scroll detection service to load more items
        this.$infiniteScroll = this._dataScrollService.pageToLoad$.pipe(takeWhile(() => this.products.length < this.productsSecondary.length)).subscribe(pageNumber => {
            // Complete array with new products
            this.products = this._sortProductsByDepartmentName(this.products);
            this.products = this.productsSecondary.slice(0, this.infiniteScrollItems * pageNumber);
            this.infiniteScrollPage = pageNumber;
            this.showLoader();
            // Check required by aisle sort option
            this.isAisleSort = this.activeSortRule && this.activeSortRule.field === this._sortService.getSortByName('aisles').field;
            this.isGroupInit = false;
            this.hasGroupHeading();
            this.calculateProductsPerRowInPCRedesign();
            // Hide the spinner when all maximum pages were reached
            if (this.products.length === this.productsSecondary.length) {
                this.hideLoader();
            }
        });
    }
    checkRestrictedItems() {
        this.unAttendDeliveryFlag = true;
    }
    loadSort() {
        if (this.objGridData.doGenericFlow || (this.objGridData.apiType !== 'c-products-by-upc-drawer' && this.objGridData.apiType !== 's-bogo')) {
            return true;
        }
        else {
            return false;
        }
    }
    removedProduct($productName) {
        this.afbEvent = 'Product ' + $productName + ' was removed';
    }
    /**
     * Scroll softly to the top and hide the button
     */
    backToTopOnClick() {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
        this.showBackToTopButton = false;
        const objTitleText = $('.title-bg h2.simple-page-title-text').get(0);
        if (objTitleText !== undefined) {
            objTitleText.focus();
        }
    }
    _processNoData() {
        this.products = [];
        this.productsPerRowInPCRedesign = 0;
        this.displayNoResults = true;
        $('#loadingConMedium').hide();
        if ((this.objGridData.apiType === 'c-bogo' || this.productGridPage === 'bogo')
            && window['AB']['COMMON'].getBreakpoint() !== 'mobile') {
            this.noResults = this._productGridService.getNoResultsMsg(this.productGridPage);
            if ($('.bogo--error').length !== 0) {
                $('.bogo--error').html(this.noResults).removeClass('mask');
                $('.bogo--paragraph').addClass('mask');
            }
            else {
                $('.bogo--paragraph').after('<div class="bogo--error">' + this.noResults + '</div>');
            }
            this.noResults = '';
        }
        if (this.productGridPage === 'search') {
            this.searchResult(0);
            this._http.get(window['AB']['aisleHTMLTitlePath'], { 'responseType': 'text' })
                .subscribe(htmlTitlePath => {
                this.aisleHTML = htmlTitlePath;
                this._http.get(window['AB']['aisleHTMLPath'], { 'responseType': 'text' })
                    .subscribe(htmlPath => {
                    this.aisleHTML += htmlPath;
                });
            });
        }
        // README: Hide server side load-more button
        if (this.component.pagination.load_type === 'loadmore'
            && this.component.pagination.paginate_at === 'server') {
            this.hasServerSideLoadMore = false;
        }
        if (this.hasServerSideLoadMore) {
            this.isServerGridLoading = false;
            this.hasServerSideLoadMore = false;
        }
    }
    filterSnsNextOrderBpns(products) {
        //filter the products that have bpns equal to the ones equal in the snsNextOrderBpns localstorage object
        const lsSnsNextOrderBpns = localStorage.getItem('snsNextOrderBpns');
        if (lsSnsNextOrderBpns) {
            const snsNextOrderBpns = JSON.parse(lsSnsNextOrderBpns);
            return products.filter(product => !snsNextOrderBpns.hasOwnProperty(product.id));
        }
        return products;
    }
    /**
     * Load next set of products when load more buttons is clicked.
     *
     * @param {string} call Call origin, act different if on init or button click.
     */
    loadMoreProducts(call) {
        let newItemToFocus;
        if (call === 'grid_button') {
            // Load more button is pressed, move focus to new products.
            newItemToFocus = this.products.length;
            this.component.pagination.page++;
        }
        if (call === 'grid_button' && this.isOneTimeSns && this.searchKeyword?.length > 0) {
            //* Make API call for sns one time to get and set more products
            this._setMoreProducts(newItemToFocus);
        }
        else {
            this._showMoreProducts(newItemToFocus);
        }
        if (window['AB'] && window['AB']['DATALAYER'] && this.isOneTimeSns && call === 'grid_button') {
            window['AB']['DATALAYER'].setLinkClickEvents(`ota-${this.searchKeyword?.length > 0 ? 'search-results' : 'bia'}:load-more|page:${this.component.pagination.page - 1}`);
        }
    }
    /**
     * Make Search API call to load more products onto grid
     */
    _setMoreProducts(newItemToFocus) {
        this.isServerGridLoading = true;
        this._productGridService.getMoreSearchProducts(this.searchKeyword, (this.component.pagination.page - 1) * this.component.pagination.load_items, this.component.pagination.load_items, this.snsFulfillmentType)
            .subscribe((productsData) => {
            if (productsData.products && productsData?.products?.length > 0) {
                this.productsSecondary = this.productsSecondary.concat(this.filterSnsNextOrderBpns(productsData.products));
            }
            this.numOfReceivedProducts = productsData?.products?.length ?? 0;
            if (productsData.offers) {
                this.dataOffers['offers'] = { ...this.dataOffers?.['offers'], ...productsData.offers };
            }
            this.isServerGridLoading = false;
            this._showMoreProducts(newItemToFocus);
        }, (error) => {
            this.component.pagination.page--;
            this.isServerGridLoading = false;
            this._commonService.dispatchSnsOneTimeEvent('loadMoreUpdateError', {});
        });
    }
    _showMoreProducts(newItemToFocus) {
        this.productsSecondary = this._sortProductsByDepartmentName(this.productsSecondary);
        this.products = this.productsSecondary.slice(0, this.component.pagination.load_items * this.component.pagination.page);
        // AR Project
        const products = [...this.products];
        this.arProductsArray = this.chunkArray(products || []);
        // Check required by aisle sort option.
        //this.isAisleSort = this.activeSortRule && this.activeSortRule.field === this._sortALV1Service.getSortByName('aisles').field;
        this.isGroupInit = false;
        this.hasGroupHeading();
        // Move focus to new items.
        if (newItemToFocus && this.products[newItemToFocus].id) {
            const newID = '.product-title#pg' + this.products[newItemToFocus].id;
            $(newID).ready(() => $(newID).focus());
        }
        this.calculateProductsPerRowInPCRedesign();
    }
    /**
     * Load next set of products from a server call HTTP request.
     *
     * @param {string} call Call origin, act different if on init or button click.
     */
    loadMoreProductsServerSide(call) {
        this._isServerLoadMoreTriggered = true;
        this.isServerGridLoading = true;
        if (call === 'grid_button') {
            // Load more button is pressed, move focus to new products.
            this._serverNewItemToFocus = this.products.length;
        }
        switch (this.objGridData.drivenType) {
            case 'purchase':
                switch (this.objGridData.apiType) {
                    case 'buy-it-again':
                        // README: Increment pageNumber value before API call
                        this.objGridData.value.pageNumber = this.objGridData.value.pageNumber + 1;
                        // README: Proceed with the API call for data.
                        this._init();
                        break;
                    default:
                        // Sanity check
                        // FIXME: If flow is introduced here, then move the flag reset after request response parsing is complete.
                        this._isServerLoadMoreTriggered = false;
                        break;
                }
                break;
            default:
                // Sanity check
                // FIXME: If flow is introduced here, then move the flag reset after request response parsing is complete.
                this._isServerLoadMoreTriggered = false;
                break;
        }
    }
    /**
     * Grab the items suited for the device width, breakpoints are from bootstrap media queries.
     *
     * @default mobile  15 items per page.
     * @default tablet  20 items per page.
     * @default desktop 30 items per page.
     */
    _getLoadMoreItems() {
        if (window.innerWidth <= 768) {
            return this._componentElement.getAttribute('data-load-more-mobile-items')
                ? this._componentElement.getAttribute('data-load-more-mobile-items')
                : 15;
        }
        else if (window.innerWidth > 768 && window.innerWidth <= 992) {
            return this._componentElement.getAttribute('data-load-more-tablet-items')
                ? this._componentElement.getAttribute('data-load-more-tablet-items')
                : 20;
        }
        // width above 992px
        return this._componentElement.getAttribute('data-load-more-desktop-items')
            ? this._componentElement.getAttribute('data-load-more-desktop-items')
            : 30;
    }
    /**
     * Checks the respective product is available or not
     */
    isItemAvailable(product) {
        return this._commonService.isItemAvailable_v2(product);
    }
    /**
     * Based on device type, divide product array into different chunks
     * Other than mobile view we display 4 product cards per row
     */
    chunkArray(products) {
        const chunkSize = window.location.href.includes("foru/offer-details") ? 6 : 4;
        const size = window.innerWidth < 768 ? 2 : chunkSize;
        var subArray = [];
        while (products.length) {
            subArray.push(products.splice(0, size));
        }
        return subArray;
    }
    checkAnyArProductInRow(product) {
        // Using product UPC, first it will check for corresponding product and then corresponding subArray (i.e. row)
        if (this.configObj.programType === '1P_SNS') {
            return false;
        }
        const subArray = this.arProductsArray ? this.arProductsArray.find(item => item.find(item1 => item1.pid === product.pid)) : [];
        return subArray ? this.checkAnyProductHasAddlInfo(subArray) : false;
    }
    calculateProductsPerRowInPCRedesign() {
        if (this.products.length > 0) {
            setTimeout(() => {
                const containerElement = document.querySelector('.pc-grid');
                const productElement = document.querySelector('.pc-grid-prdItem');
                if (containerElement && productElement) {
                    this.productsPerRowInPCRedesign = Math.round((containerElement).offsetWidth / (productElement).offsetWidth);
                    this.fullWidthIndicies = new Map();
                    this.getFullWidthIndicies();
                }
            }, 0);
        }
    }
    getFullWidthIndicies() {
        this.products?.forEach((product, index) => {
            const rowIndex = Math.floor(index / this.productsPerRowInPCRedesign);
            const isLastInRow = (index + 1) % this.productsPerRowInPCRedesign === 0;
            const carouselIndex = (rowIndex + 1) + this.fullWidthIndicies.size;
            if (isLastInRow && this.gridCarousels.has(carouselIndex)) {
                this.fullWidthIndicies.set(index + 1, carouselIndex);
            }
        });
        this.fullWidthIndicies?.forEach((value, key) => {
            const carouselConfig = this.gridCarousels.get(value);
            if (carouselConfig) {
                this.products.splice(key, 0, {});
            }
        });
        setTimeout(() => {
            this.fullWidthIndicies?.forEach((value, key) => {
                const carouselConfig = this.gridCarousels.get(value);
                if (carouselConfig) {
                    this.renderMasterProductCarousel(carouselConfig, key);
                }
            });
        }, 0);
    }
    renderMasterProductCarousel(carouselConfig, index) {
        if ((!carouselConfig?.response?.docs || carouselConfig.response.docs.length <= 0)
            && (!carouselConfig?.productsinfo || carouselConfig.productsinfo.length <= 0)) {
            console.warn("No data available for Master Product Carousel");
            return;
        }
        const container = document.getElementById('gridZoneContent' + index);
        const products = this.prepareJSON(carouselConfig);
        container.querySelectorAll('.slick-product-carousel')?.forEach((element) => element.remove());
        container.insertAdjacentHTML('beforeend', `<div class="slick-product-carousel">
            <${this.wrapperName}
                  ${this.wrapperAttribute}="product-carousel"
                  data-home-targeted="true"
                  data-carousel-type="generic-products"
                  data-carousel-title="${carouselConfig.carouselTitle}"
                  data-carousel-users="${carouselConfig.hideOnLoading == 'mask' ? carouselConfig.userType : 'false'}"
                  data-carousel-action="${carouselConfig.actionButton == null ? 'qty-stepper' : carouselConfig.actionButton}"
                  data-carousel-behaviour="${carouselConfig.behaviourType == null ? 'false' : carouselConfig.behaviourType}"
                  data-experimentation="${carouselConfig.webExperimentation}"
                  data-experimentation-id="${carouselConfig.webExperimentationId}"
                  data-experimentation-type="${carouselConfig.webExperimentationType}"
                  data-impression-tracking="${carouselConfig.webIsImpTrackEnabled}"data-products='${products}'data-carousel-max-products="${carouselConfig.maxNumOfProducts}"
                  data-include-offer="${carouselConfig.includeOffer}"
                  data-navigation-type="${carouselConfig.navigationType}"
                  data-cart-type="${carouselConfig.cartType}"
                  data-filter-cart-items="${carouselConfig.filterCartItems}"
                  data-seller-type="${carouselConfig.sellerType}"
                  data-carousel-pdp="false"
                  id="${carouselConfig.itemName}">
            </${this.wrapperName}>
            </div>`);
        this.bootstrapAngular();
    }
    bootstrapAngular() {
        if (window['appConfigServiceRef'] != undefined) {
            window['appConfigServiceRef'].zone.run(() => {
                window['appConfigServiceRef'].service.initTargetedWrapper();
            });
        }
    }
    prepareJSON(data) {
        return JSON.stringify(data).replace(/'/g, "&apos;");
    }
    _sendProductsToAddAllComponent(productsData) {
        let products = productsData.products;
        if (this.objGridData.apiType === 'c-virtual-shelf-general') {
            if (products.length > 50 || products.length === 0 || $('.load-more').length > 0) {
                $('.dynamic-angular-content-injector').hide();
            }
            else {
                $('.dynamic-angular-content-injector').show();
                //README: send only in stock products(inventoryAvailable === "1")
                products = products.filter(item => item.inventoryAvailable === "1");
                this._commonService._products.next(products);
            }
        }
    }
    showLoader() {
        this._loaderService.show();
    }
    hideLoader() {
        this._loaderService.hide();
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    static { this.ɵfac = function ProductGenericGridALV1Component_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ProductGenericGridALV1Component)(i0.ɵɵdirectiveInject(ProductGenericGridALV1Service), i0.ɵɵdirectiveInject(i1.HttpClient), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i3.CommonService), i0.ɵɵdirectiveInject(i3.UserInfoService), i0.ɵɵdirectiveInject(i3.AemService), i0.ɵɵdirectiveInject(SortALV1Service), i0.ɵɵdirectiveInject(i3.CartService), i0.ɵɵdirectiveInject(i3.DatasScrollService), i0.ɵɵdirectiveInject(i3.ProductFilterService), i0.ɵɵdirectiveInject(i3.LoaderService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProductGenericGridALV1Component, selectors: [["product-generic-grid-al-v1"]], inputs: { dataValue: "dataValue", staticProducts: "staticProducts", qualifiedProducts: "qualifiedProducts", configObj: "configObj", objGridData: "objGridData", calledBy: "calledBy", gridCarousels: "gridCarousels", replacementProducts: "replacementProducts", additionalProducts: "additionalProducts" }, features: [i0.ɵɵProvidersFeature([SortALV1Service, ProductGenericGridALV1Service, DatasScrollService, LoaderService])], decls: 2, vars: 2, consts: [["class", "product-level-1 container-fluid p0", "style", "color: #5A5A5A; font-size: 20px;", "data-qa", "prd-gnrc-grd", 4, "ngIf"], ["class", "product-level-4", 4, "ngIf"], ["data-qa", "prd-gnrc-grd", 1, "product-level-1", "container-fluid", "p0", 2, "color", "#5A5A5A", "font-size", "20px"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"], [3, "innerHTML"], [1, "product-level-4"], [3, "sortRules", "activeSortRule", "ngClass", "activeSortRuleEmitter", 4, "ngIf"], [1, "pc-grid", "w-100", "gutters-items-v2", "product-grid-v2", "product-card-grid", 3, "ngClass"], [4, "ngFor", "ngForOf"], [1, "pc__col-full-width"], ["aria-live", "polite", "aria-atomic", "true", 1, "visuallyhidden"], ["class", "row justify-content-center", 4, "ngIf"], ["id", "searchGridLoading", "class", "loading-div-medium", 4, "ngIf"], ["class", "load-more-container", 4, "ngIf"], [3, "activeSortRuleEmitter", "sortRules", "activeSortRule", "ngClass"], ["class", "section-heading product-group sort-by-aisle pc__col-full-width", 4, "ngIf"], [4, "ngIf"], [1, "section-heading", "product-group", "sort-by-aisle", "pc__col-full-width"], ["data-qa", "prd-itm", 1, "pc-grid-prdItem", "h-100", 3, "isRestrictedChange", "isRestricted", "data", "offers", "calledBy", "configObj", "isCalledByRightDrawerOrSns"], [1, "col-12", "bia-spa-carousel-container", "sponsored-container"], [1, "bia-spa-carousel-container-header"], [3, "id"], [1, "row", "justify-content-center"], ["role", "button", 1, "bloom-load-button", "btn", "btn-secondary", "btn-xl", "mt-3", 3, "click"], ["id", "searchGridLoading", 1, "loading-div-medium"], [1, "loading-spinner"], ["alt", "Loading...", 1, "large", "progress"], [1, "prog1"], [1, "prog2"], [1, "load-more-container"], ["role", "button", 1, "btn", "btn-default", "btn-secondary", "load-more", 3, "click"]], template: function ProductGenericGridALV1Component_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ProductGenericGridALV1Component_div_0_Template, 2, 1, "div", 0)(1, ProductGenericGridALV1Component_div_1_Template, 10, 9, "div", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.displayNoResults && (ctx.products.length == 0 || !ctx.allowNotAvailable && ctx.areAllProductsUnavailable));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showGrid && ctx.products.length > 0 && (ctx.allowNotAvailable || !ctx.areAllProductsUnavailable));
        } }, dependencies: [i5.NgClass, i5.NgForOf, i5.NgIf, i6.ProductItemALV2Component, i7.SortAlV1Component], encapsulation: 2 }); }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProductGenericGridALV1Component, factory: ProductGenericGridALV1Component.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductGenericGridALV1Component, [{
        type: Component,
        args: [{ selector: 'product-generic-grid-al-v1', providers: [SortALV1Service, ProductGenericGridALV1Service, DatasScrollService, LoaderService], template: "<!-- <p>product-generic-grid works!</p> -->\n\n<!-- No results -->\n<div class=\"product-level-1 container-fluid p0\" *ngIf=\"(displayNoResults && (products.length == 0 || (!allowNotAvailable && areAllProductsUnavailable)))\" style=\"color: #5A5A5A; font-size: 20px;\" data-qa=\"prd-gnrc-grd\">\n    <div [ngClass]=\"{'no-results': true, 'search-no-results': searchNoResults}\" *ngIf=\"showGrid\">\n        <div [innerHTML]=\"noResults\"></div>\n        <div [innerHTML]=\"aisleHTML\"></div>\n    </div>\n</div>\n\n<!-- Product grid -->\n<div class=\"product-level-4\" *ngIf=\"(showGrid) && (products.length > 0) && (allowNotAvailable || !areAllProductsUnavailable)\">\n    <sort-by *ngIf=\"(products.length > 0) && hasSort && loadSort()\"\n        [sortRules]='sortRules'\n        [activeSortRule]='activeSortRule'\n        (activeSortRuleEmitter)='activeSortRuleEmitter($event)'\n        [ngClass]=\"{'bia-sort': biaSort}\">\n    </sort-by>\n\n\n    <div [ngClass]=\"{'pc-grid-contained':isCalledByRightDrawerOrSns}\" class=\"pc-grid w-100 gutters-items-v2 product-grid-v2 product-card-grid\">\n\n        <ng-container *ngFor=\"let product of products; let i = index;\">\n            <div class=\"section-heading product-group sort-by-aisle pc__col-full-width\" *ngIf=\"product.isGroupSplit && isAisleSort && loadSort()\">\n                <h2>{{product[groupByField]}}</h2>\n            </div>\n\n            <ng-container *ngIf=\"!fullWidthIndicies.has(i)\"> \n                <product-item-al-v2 \n                    [(isRestricted)]=\"unAttendDeliveryFlag\"\n                    [data]=\"product\"\n                    [offers] = \"dataOffers\"\n                    [calledBy]=\"calledBy\"\n                    data-qa=\"prd-itm\"\n                    [configObj]=\"configObj\"\n                    class=\"pc-grid-prdItem h-100\"\n                    [isCalledByRightDrawerOrSns] = \"isCalledByRightDrawerOrSns\">\n                </product-item-al-v2>\n            </ng-container>\n\n            <ng-container *ngIf=\"gridCarousels.size > 0 && fullWidthIndicies.has(i)\">\n                <div class=\"pc__col-full-width\" > \n                    <div class=\"col-12 bia-spa-carousel-container sponsored-container\">\n                        <span class=\"bia-spa-carousel-container-header\"> {{ gridCarousels.get(fullWidthIndicies.get(i))?.carouselTitle}} </span> \n                        <div [id]=\"'gridZoneContent'+i\"></div>  \n                    </div>\n                </div>\n            </ng-container>\n\n        </ng-container>\n        <div class=\"pc__col-full-width\"></div>\n    </div>\n\n    <!-- AFB polite for removed products -->\n    <div aria-live=\"polite\" aria-atomic=\"true\" class=\"visuallyhidden\">{{afbEvent}}</div>\n\n    <div class=\"row justify-content-center\" *ngIf=\"(component.pagination.load_type == 'loadmore') && !isServerGridLoading && (products.length < productsSecondary.length || (isOneTimeSns && numOfReceivedProducts >= 30 && searchKeyword.length>0))\">\n        <button role=\"button\" class=\"bloom-load-button btn btn-secondary btn-xl mt-3\" (click)=\"loadMoreProducts('grid_button');\">Load more</button>  \n    </div>\n\n    <div id=\"searchGridLoading\" class=\"loading-div-medium\" *ngIf=\"isServerGridLoading\">\n        <div class=\"loading-spinner\">\n            <div class=\"large progress\" alt=\"Loading...\"><div class=\"prog1\"><div class=\"prog2\"></div></div></div>\n        </div>\n    </div>\n    \n    <div class=\"load-more-container\" *ngIf=\"hasServerSideLoadMore && !isServerGridLoading\">\n        <button class=\"btn btn-default btn-secondary load-more\" role=\"button\" (click)=\"loadMoreProductsServerSide('grid_button');\">Load more</button>\n    </div>\n</div>\n" }]
    }, {
        type: Injectable
    }], () => [{ type: ProductGenericGridALV1Service }, { type: i1.HttpClient }, { type: i0.NgZone }, { type: i0.ElementRef }, { type: i3.CommonService }, { type: i3.UserInfoService }, { type: i3.AemService }, { type: SortALV1Service }, { type: i3.CartService }, { type: i3.DatasScrollService }, { type: i3.ProductFilterService }, { type: i3.LoaderService }], { dataValue: [{
            type: Input
        }], staticProducts: [{
            type: Input
        }], qualifiedProducts: [{
            type: Input
        }], configObj: [{
            type: Input
        }], objGridData: [{
            type: Input
        }], calledBy: [{
            type: Input
        }], gridCarousels: [{
            type: Input
        }], replacementProducts: [{
            type: Input
        }], additionalProducts: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ProductGenericGridALV1Component, { className: "ProductGenericGridALV1Component", filePath: "product-generic-grid-al-v1/product-generic-grid-al-v1.component.ts", lineNumber: 44 }); })();

class ProductGenericGridModule {
    static { this.ɵfac = function ProductGenericGridModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ProductGenericGridModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ProductGenericGridModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            ProductGenericGridALV1Component,
            ProductGenericGridALV1Service,
            ProductCatalogALV1Service
        ], imports: [CommonModule,
            ProductItemALV1Module,
            ProductItemALV2Module,
            SortByAlV1Module] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductGenericGridModule, [{
        type: NgModule,
        args: [{
                declarations: [ProductGenericGridALV1Component],
                exports: [
                    ProductGenericGridALV1Component,
                ],
                imports: [
                    CommonModule,
                    ProductItemALV1Module,
                    ProductItemALV2Module,
                    SortByAlV1Module
                ],
                providers: [
                    ProductGenericGridALV1Component,
                    ProductGenericGridALV1Service,
                    ProductCatalogALV1Service
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ProductGenericGridModule, { declarations: [ProductGenericGridALV1Component], imports: [CommonModule,
        ProductItemALV1Module,
        ProductItemALV2Module,
        SortByAlV1Module], exports: [ProductGenericGridALV1Component] }); })();

// //Component

/**
 * Generated bundle index. Do not edit.
 */

export { ProductGenericGridALV1Component, ProductGenericGridALV1Service, ProductGenericGridModule };
